import TagText from "./TagText";

export default TagText;
